import * as React from 'react';
import { connect } from 'react-redux';
import { Text } from 'wix-ui-tpa/Text';
import { TextButton } from 'wix-ui-tpa/TextButton';
import { useTranslation } from 'react-i18next';
import { MOBILE_BIO_DISPLAY_OPTIONS } from '../../../../constants/settingsConstants';
import triggerEvent from '../../../../actions/services/biSiteLogger';
import biData from '../../../../bi/profileEvents.json';
import { st, classes } from './ProfileMoreInfo.st.css';

const ProfileMoreInfo = ({
  user,
  isMobile,
  isDisplayProfileBio,
  m_displayBio,
  isConnected,
}) => {
  const { t } = useTranslation();
  const { name, biography, website } = user;
  const [isShowMoreDetailsMobile, onClickShowMoreMobile] =
    React.useState(false);

  if (!name && !biography && !website) {
    return null;
  }
  if (!isMobile && !isDisplayProfileBio) {
    return null;
  }

  const isSeeMoreBtnEnabled =
    isMobile && m_displayBio === MOBILE_BIO_DISPLAY_OPTIONS.SEE_MORE_BTN;
  return isSeeMoreBtnEnabled && !isShowMoreDetailsMobile ? (
    <TextButton
      className={st(classes.SeeMoreBtn, { isMobile, isSeeMore: true })}
      onClick={() => onClickShowMoreMobile(true)}
    >
      {t('profileHeader.seeMore')}
    </TextButton>
  ) : (
    <div>
      <Text className={st(classes.ProfileName, { isMobile })}>{name}</Text>
      <Text className={st(classes.UserIntro, { isMobile })}>{biography}</Text>
      <TextButton
        className={st(classes.WebsiteBtn, { isMobile })}
        priority="primary"
        onClick={() => {
          if (isConnected) {
            window.open(website, '_blank');
            triggerEvent(biData.CLICK_ON_BIO_LINK);
          }
        }}
      >
        {website}
      </TextButton>
      {isSeeMoreBtnEnabled ? (
        <TextButton
          className={st(classes.SeeMoreBtn, { isMobile })}
          onClick={() => onClickShowMoreMobile(false)}
        >
          {t('profileHeader.seeLess')}
        </TextButton>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.appReducer.user,
  isConnected: state.appReducer.isConnected,
  isMobile: state.appReducer.isMobile,
  isDisplayProfileBio: state.settingsReducer.isDisplayProfileBio,
  m_displayBio: state.settingsReducer.m_displayBio,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileMoreInfo);
